/**
 * 请求地址配置 JS
 * @Author 吴成林
 * @Date 2022-1-10 17:29:35
 */
const UrlConfig = {
  /**
   *  会员登录
   * @Author 吴成林
   * @Date 2022-1-10 17:30:40
   */
  auth_member_accredit: '/auth/member/accredit',

  /**
   *  会员详情
   * @Author 吴成林
   * @Date 2022-1-10 17:30:40
   */
  member_member_detailsPageMember: '/member/member/detailsPageMember',

  /**
   *  车险 - 险别初始化查询
   * @Author 吴成林
   * @Date 2023-5-5 16:52:29
   */
  management_quotecarinsurance_kindsInit: '/management/quotecarinsurance/kindsInit',

  /**
   *  车险 - 保存险别险种及询价
   * @Author 吴成林
   * @Date 2023-5-5 16:52:29
   */
  management_quotecarinsurance_priceQuote: '/management/quotecarinsurance/priceQuote',

  /**
   *  车险 - 报价转投保
   * @Author 吴成林
   * @Date 2023-5-5 16:52:29
   */
  management_quotecarinsurance_quoteToOrder: '/management/quotecarinsurance/quoteToOrder',

  /**
   *  车险 - 投保单回填
   * @Author 吴成林
   * @Date 2023-6-29 14:13:50
   */
  management_quotecarinsurance_getRelationInfo: '/management/quotecarinsurance/getRelationInfo',

  /**
   * 绑定投保订单 -> 见费出单 -> 第三方支付数据
   * @Author 肖家添
   * @Date 2020/7/7 16:20
   */
  management_mobileInsuranceInfo_bindSellBillAtCostHandler: "/management/mobileInsuranceInfo/bindSellBillAtCostHandler",

  /**
   * 文件上传-用于复杂业务操作  ``POST [file, formType, formId, ...]
   */
  upload_attachment_uploadFileByComplex: "/upload/attachment/uploadFileByComplex",

  /**
   * 上传图片
   */
  upload_attachment_upload: '/upload/attachment/upload',

  /**
   *  车险 - 获取分享token
   * @Author 吴成林
   * @Date 2023-5-5 16:52:29
   */
  management_quotecarinsurance_createShareToken: '/management/quotecarinsurance/createShareToken',

  /**
   * 保险产品库详情
   */
  insuranceInfo_detail: "/management/mobileInsuranceInfo/getInsuranceDetail",

  /**
   * 产品详情 -> 立即投保所需的数据
   */
  insuranceInfo_detail_immediatelyData: "/management/mobileInsuranceInfo/getInsuranceNeedData",

  /**
   * 产品投保sku - 动态数据加载
   */
  management_mobileInsuranceInfo_getInsuranceSkuDetail: '/management/mobileInsuranceInfo/getInsuranceSkuDetail',

  /**
   * 投保详情 -> 投保校验
   */
  insuranceInfo_detail_immediateInsurance: "/management/mobileInsuranceInfo/immediateInsurance",

  /**
   * 产品 -> 订单生成
   */
  insuranceInfo_orderHandler: "/management/mobileInsuranceInfo/orderHandler",

  /**
   * 投保资料 -> 订单提交
   */
  insuranceInfo_submitOrderHandler: "/management/mobileInsuranceInfo/submitOrderHandler",

  /**
   * 订单详情
   */
  insuranceInfo_loadOrderDetail: "/management/mobileInsuranceInfo/loadOrderDetail",

  /**
   * 订单支付前数据校验
   */
  insuranceInfo_orderPaymentBefore: "/management/mobileInsuranceInfo/orderPaymentBefore",


};

export default UrlConfig;



// WEBPACK FOOTER //
// ./src/tool/UrlConfig.js